import { ShieldCheck } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { ASSO } from "@/constants";

export default function PrivacyPolicy() {
  return (
    <div className="py-12 sm:py-16 lg:py-20" data-testid="privacy-policy-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-emerald-600 mb-2">RGPD</p>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900" data-testid="privacy-policy-title">Politique de confidentialité</h1>
        </div>

        <Card className="border-slate-200">
          <CardContent className="p-6 sm:p-8 space-y-6 text-sm leading-relaxed text-slate-600">
            <section className="space-y-2">
              <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-emerald-600" />Responsable de traitement</h2>
              <p>
                {ASSO.name}, association loi 1901 — Toury (28310). Contact pour toute question relative à vos
                données : <a href={`mailto:${ASSO.email}`} className="text-sky-700 hover:underline">{ASSO.email}</a>.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-lg font-bold text-slate-900">Données collectées et finalités</h2>
              <ul className="list-disc pl-5 space-y-1.5">
                <li><strong>Compte adhérent</strong> : adresse e-mail, identifiant HelloAsso — gestion de l'adhésion, accès aux comptes rendus et aux participations (base légale : exécution du contrat d'adhésion).</li>
                <li><strong>Participations aux événements</strong> : nombre d'adultes/enfants, créneaux — organisation logistique des manifestations (intérêt légitime).</li>
                <li><strong>Candidatures Liste CET</strong> : identité, coordonnées, classe de l'enfant, justificatif — constitution de la liste de candidats aux élections de parents d'élèves (obligation légale et consentement).</li>
                <li><strong>Messages de contact</strong> : nom, e-mail, message — réponse aux demandes (intérêt légitime).</li>
                <li><strong>Statistiques d'audience</strong> : pages vues et visiteurs uniques (adresses IP hachées, non réidentifiables) — mesure d'audience anonymisée.</li>
              </ul>
            </section>

            <section className="space-y-2">
              <h2 className="text-lg font-bold text-slate-900">Cookies</h2>
              <p>
                Le site utilise uniquement des <strong>cookies techniques strictement nécessaires</strong> au
                fonctionnement (session de connexion, préférences d'affichage). Aucun cookie publicitaire ni de
                pistage tiers n'est déposé. Vous pouvez les refuser sans impact sur la consultation du site.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-lg font-bold text-slate-900">Durées de conservation</h2>
              <p>
                Données d'adhésion : durée de l'adhésion + 1 an. Candidatures : durée du processus électoral +
                1 an. Messages de contact : 12 mois. Statistiques d'audience : 13 mois maximum.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-lg font-bold text-slate-900">Sous-traitants</h2>
              <p>
                Hébergement cloud sécurisé, envoi d'e-mails transactionnels (vérification de compte, réinitialisation
                de mot de passe) et plateforme HelloAsso pour l'adhésion. Aucune donnée n'est vendue ni cédée à des
                tiers à des fins commerciales.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-lg font-bold text-slate-900">Vos droits</h2>
              <p>
                Vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition et de portabilité de
                vos données. Exercez-les par e-mail à <a href={`mailto:${ASSO.email}`} className="text-sky-700 hover:underline">{ASSO.email}</a>.
                Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
